module.exports = {"650172001":"高新街街道","650172002":"长春中路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650172.json
// module id = 3057
// module chunks = 0